// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-show-collections-output-shell-collections-output-collection-name__16jec {\n  font-weight: bold;\n}\n.mongosh-show-collections-output-shell-collections-output-system-collection__19HQZ {\n  color: #89979b;\n}\n", ""]);
// Exports
exports.locals = {
	"shell-collections-output-collection-name": "mongosh-show-collections-output-shell-collections-output-collection-name__16jec",
	"shell-collections-output-system-collection": "mongosh-show-collections-output-shell-collections-output-system-collection__19HQZ"
};
module.exports = exports;
